import { render } from "./FlaggedPasses.vue?vue&type=template&id=55f54a9e"
import script from "./FlaggedPasses.vue?vue&type=script&lang=js"
export * from "./FlaggedPasses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__